(function () {
  var widget = document.querySelector('[data-kit-finder]');
  if (!widget) return;

  var dataEl = document.getElementById('kit-finder-data');
  var data = {};
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var steps = widget.querySelectorAll('.kit-finder__step');
  var selectedPower = null;

  function showStep(name) {
    steps.forEach(function (step) {
      step.dataset.active = step.dataset.step === name ? 'true' : 'false';
    });
  }

  function renderResult() {
    var battery = widget.dataset.batteryChoice;
    var list = battery === 'yes' ? data.bundles : data.kits;
    var match = list.filter(function (item) {
      return item.power === selectedPower;
    })[0];

    var resultEl = widget.querySelector('[data-result]');
    if (!match) {
      resultEl.innerHTML = '<p class="kit-finder__no-match">We could not find a match for that combination yet — browse all kits instead.</p>';
      showStep('result');
      return;
    }

    resultEl.innerHTML =
      '<div class="kit-finder__result-card">' +
        (match.image ? '<img src="' + match.image + '" alt="' + match.title + '" class="kit-finder__result-image" loading="lazy">' : '') +
        '<div class="kit-finder__result-body">' +
          '<span class="kit-finder__result-label">Recommended for you</span>' +
          '<h3 class="kit-finder__result-title">' + match.title + '</h3>' +
          '<span class="kit-finder__result-price">' + match.price + '</span>' +
          '<a href="' + match.url + '" class="kit-finder__result-cta">View this kit &rarr;</a>' +
        '</div>' +
      '</div>';

    showStep('result');

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish('kit_finder_recommendation', {
        power: selectedPower,
        battery: battery,
        recommendedProduct: match.title
      });
    }
  }

  widget.addEventListener('click', function (e) {
    var powerBtn = e.target.closest('[data-power]');
    if (powerBtn) {
      selectedPower = powerBtn.dataset.power;
      showStep('2');
      return;
    }

    var batteryBtn = e.target.closest('[data-battery]');
    if (batteryBtn) {
      widget.dataset.batteryChoice = batteryBtn.dataset.battery;
      renderResult();
      return;
    }

    if (e.target.closest('[data-back]')) {
      showStep('1');
      return;
    }

    if (e.target.closest('[data-restart]')) {
      selectedPower = null;
      showStep('1');
    }
  });
})();
